import {
  BENCHMARK_CONFIGURATION,
  TIME_SELECTOR_DATE_CHANGED,
} from "./constants";

export const setBenchmarkConfiguration = (portfolio_id, modal_opened, configuration_required, forceShow) => ({
  type: BENCHMARK_CONFIGURATION,
  portfolio_id,
  modal_opened,
  configuration_required,
  forceShow, //used for move toggle on or not after config saved
});

export const setTimeSelectorDateChange = (change) => ({
  type: TIME_SELECTOR_DATE_CHANGED,
  change
});